import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, DialogTitle, DialogContent, Typography } from '@mui/material'

import { createInstaller, updateInstaller, instaladorColaboradorAutocomplete } from '../../slices'
import { PrescriptorInstallersForm } from '../form'
import { transformFormStateToBackend } from '../../constants/prescriptor-installers-mappers.constants'

export const PrescriptorInstallersDialog = ({ installer, onClose }) => {
  const dispatch = useDispatch()
  const prescriptorId = useSelector((state) => state.global.empresa_id)
  const isEdit = !!installer?.id

  const [formState, setFormState] = useState(isEdit ? { ...installer } : {})
  const [isLoading, setIsLoading] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [searchMessage, setSearchMessage] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target || e

    setFormState((prev) => {const newState = { ...prev, [name]: value }

      if (name === 'cif' || name === 'nif') {
        newState.cif = value
        newState.nif = value
      }

      if (name === 'razon_social' || name === 'nombre') {
        newState.razon_social = value
        newState.nombre = value
      }

      return newState
    })

    if (searchMessage) setSearchMessage(null)
  }

  const handleSearchInstaller = async () => {
    const cif = (formState.cif || formState.nif || '').trim()

    if (!cif) return

    setIsSearching(true)
    setSearchMessage(null)

    try {
      const response = await dispatch(instaladorColaboradorAutocomplete(cif, prescriptorId))

      if (response) {
        setFormState((prev) => ({
          ...prev,
          ...response,
        }))
      } else {
        setSearchMessage('No se encuentra ningún instalador dado de alta para dicho campo.')
      }
    } catch (error) {
      setSearchMessage('No se encuentra ningún instalador dado de alta para dicho campo.')
    } finally {
      setIsSearching(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)
    const onSuccess = () => {
      setIsLoading(false)
      onClose()
    }
    const onError = () => {
      setIsLoading(false)
    }

    try {
      // Transformar datos al formato del backend
      const payload = transformFormStateToBackend(formState)

      if (isEdit) {
        dispatch(updateInstaller(installer.id, payload, prescriptorId, onSuccess, onError))
      } else {
        dispatch(createInstaller(payload, prescriptorId, onSuccess, onError))
      }
    } catch (error) {
      console.error('Error procesando formulario:', error)
      setIsLoading(false)
    }
  }

  return (
    <Box p={2}>
      <DialogTitle>
        <Box display="flex" justifyContent="center">
          <Typography variant="h4" color="textSecondary">
            {isEdit ? 'Editar instalador' : 'Nuevo instalador'}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <PrescriptorInstallersForm
          formState={formState}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onClose={onClose}
          onSearchInstaller={handleSearchInstaller}
          isSearching={isSearching}
          searchMessage={searchMessage}
          isLoading={isLoading}
          isEdit={isEdit}
        />
      </DialogContent>
    </Box>
  )
}
